module.exports = __webpack_public_path__ + "img/CONAHCYT_blanco.326811fa.png";